const productGrids = document.querySelectorAll('.featured-collection-grid');

if (productGrids && productGrids.length > 0) {
  productGrids.forEach((productGrid) => {
    if (productGrid.dataset.maxItems > 4) setFlickity(productGrid);
  });
}

function setFlickity(productGrid) {
  new Flickity(productGrid, {
    freeScroll: true,
    wrapAround: true,
    cellAlign: 'left',
    groupCells: 1,
    lazyLoad: true,
    arrowShape: {
      x0: 10,
      x1: 60,
      y1: 50,
      x2: 75,
      y2: 35,
      x3: 40
    }
  });
  const [...pageDots] = productGrid.querySelector(
    '.flickity-page-dots'
  ).children;

  if (!pageDots) return;

  let pageWidth = 370;
  if (screen.width <= 425) {
    pageWidth = 200;
  }
  const dotWidth = pageWidth / pageDots.length - pageDots.length / 2;
  pageDots.forEach((dot) => {
    dot.style.width = `${dotWidth}px`;
  });
}
